// Logica pura do header publico (testavel em env node, sem JSX).

/** Monta o destino do botao "Acessar" a partir da appUrl (remove barra final). */
export function buildEntrarHref(appUrl: string): string {
  return `${appUrl.replace(/\/$/, '')}/entrar`;
}

export type MegaMenuKey = 'func' | 'sobre';

export interface PublicNavItem {
  label: string;
  /** href interno quando o item ja navega; ausente em itens com mega-menu. */
  href?: string;
  /** true = item abre um mega-menu (popover bento) em vez de navegar. */
  placeholder?: boolean;
  /** chave do mega-menu aberto ao clicar (quando placeholder). */
  menu?: MegaMenuKey;
}

/** Itens centrais do dock (sem logo nem botao Acessar). */
export const PUBLIC_NAV_ITEMS: PublicNavItem[] = [
  { label: 'Funcionalidades', placeholder: true, menu: 'func' },
  { label: 'Preços', href: '/precos' },
  { label: 'Contato', href: '/contato' },
  { label: 'Sobre', placeholder: true, menu: 'sobre' },
];
